export default [
  {
    path: "/perbandingan-prodi",
    name: "perbandingan-prodi",
    component: () => import("@/views/menu/perbandingan-prodi/index.vue"),
    meta: {
      pageTitle: "Perbandingan Prodi",
      requireAuth: true,
      breadcrumb: [
        {
          text: "Perbandingan Prodi",
          active: true,
        },
      ],
    },
  },
];
